(function(){
    angular
        .module('app')
        .directive('ngTaginput', taginput);

        taginput.$inject = ['$timeout'];
        function taginput($timeout){
            return {
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    element.tagsInput({
                        type:$attrs.ngTaginput,
                        autosize:false,
                        defaultText:'Escribe aquí',
	                   	onChange: function(elem, elem_tags)
						{
                   			element.trigger("change");
						}
					});
                  
                });
            }
          }
      }
})();